<template>
  <!-- 主播出走  v-if="roomInfo"-->
  <div class="live-away">
    <div class="live-away-title">{{roomInfo.title}}</div>
    <div class="live-away-txt">主播暂时不在，请稍等片刻~</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "live-away",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      roomInfo: "getRoomInfo",
    }),
  },
  created() {
    console.log('this.roomInfo',this.roomInfo);
  } 
};
</script>

<style scoped lang="scss">
.live-away {
  width: 100vw;
  top: 27%;
  left: 0;
  position: absolute;
  z-index: 98;
  text-align: center;
  color: #fff;
}

.live-away-title {
  font-size: 0.48rem;
  margin:0 auto 0.56rem;
}

.live-away-txt {
  font-size: 0.3rem;
  margin-bottom: 0.42rem;
}

</style>
